import type { INavLinksResponse } from './types';

/* eslint-disable max-len */
export default function (
  defaultLocale: string,
  sections: {
    title: any,
    enabled?: boolean,
    countries?: string[],
    items: {
      title: any;
      externalPath?: string;
      path?: string;
      enabled?: boolean;
      countries?: string[],
  }[] }[],
): INavLinksResponse[] {
  return sections
    .filter((route) => route?.countries?.includes(defaultLocale) || !route.countries)
    .filter((route) => route.enabled || route.enabled !== false)
    .map((route) => ({
      ...route,
      items: route.items
        .filter((item) => item?.countries?.includes(defaultLocale) || !item?.countries)
        .filter((item) => item.enabled || item.enabled !== false)
        .map((item) => ({ ...item, path: `/${defaultLocale}${item.path}` })),
    }));
}
